import { Controller } from '@hotwired/stimulus'

// Shows that a connection test is running until its result is broadcast, says so if none arrives in time, and names each attempt so a late earlier one cannot overwrite it
export default class extends Controller {
  static targets = ['result', 'pending', 'stalled']
  static values = { timeout: { type: Number, default: 30000 } }

  disconnect () {
    clearTimeout(this.timer)
  }

  start (event) {
    this.attempt = this.newAttempt()
    this.attemptField(event.currentTarget.form).value = this.attempt

    const current = document.createElement('div')
    current.id = `kafka_integration_connection_test_${this.attempt}`
    current.append(this.pendingTarget.content.cloneNode(true))
    this.resultTarget.replaceChildren(current)

    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.stall(), this.timeoutValue)
  }

  stall () {
    const current = document.getElementById(`kafka_integration_connection_test_${this.attempt}`)

    if (current && current.querySelector('[data-connection-test-pending]')) {
      current.replaceChildren(this.stalledTarget.content.cloneNode(true))
    }
  }

  newAttempt () {
    return window.crypto.randomUUID()
  }

  attemptField (form) {
    const name = 'kafka_integration[connection_test_attempt]'
    let field = form.querySelector(`input[name="${name}"]`)

    if (!field) {
      field = document.createElement('input')
      field.type = 'hidden'
      field.name = name
      form.append(field)
    }

    return field
  }
}
